module.exports = __webpack_public_path__ + "static/media/search-icon.4252cfc1.svg";